const queryUtil = {
  /*
   * examples:
   * www.url.com/ -> www.url.com
   * www.url.com/?foo=bar -> www.url.com?foo=bar
   * www.url.com/?foo=bar/ -> www.url.com?foo=bar
   */
  parseExtraSlashes(url: string): { statusCode: number; url: string } {
    const regex = new RegExp('\\/\\?|\\/\\&', 'g');
    let statusCode = 200;

    if (url.match(regex)) {
      url = url.replace(regex, '?');
      statusCode = 301;
    }

    if (url.substr(url.length - 1) === '/') {
      url = url.slice(0, -1);
      statusCode = 301;
    }

    return {
      statusCode,
      url,
    };
  },
  stringify(obj: object): string {
    const stringArray = [];
    let prop: string;

    for (prop in obj) {
      const key = prop as keyof object;
      if (obj.hasOwnProperty(prop) || typeof obj[key] === 'boolean') {
        stringArray.push(encodeURIComponent(prop) + '=' + encodeURIComponent(obj[key]));
      }
    }

    if (stringArray.length > 0) {
      return '?' + stringArray.join('&');
    } else {
      return '';
    }
  },
  parse(url: string): object {
    const queryObj: any = {};
    let pieces: string | Array<string> = url;

    if (pieces.startsWith('?')) {
      pieces = pieces.split('?')[1];
    }
    pieces = pieces.split('&');

    pieces.forEach(function (piece) {
      const splitPiece = piece.split('=');
      const name = splitPiece[0];
      const value = splitPiece[1];

      try {
        queryObj[name] = decodeURIComponent(value);
      } catch (error) {
        return;
      }
    });

    return queryObj;
  },
  encodeQueryString(string: string): string {
    return this.stringify(this.parse(string));
  },
};

export default queryUtil;
